// import { mainStyles, theme } from '../../styles'
import { withStyles } from '@mui/styles';
import { green, red } from '@mui/material/colors';
import {
    Typography, useTheme
} from '@mui/material'
import React, { useState } from 'react'
//import { useStyles } from '../dynamicForm/DynamicFormStyles'
import { CustomCounterAppBar, CustomLoadingOverlay, Buttons } from '../../components'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

const GreenCheckbox = withStyles({
    root: {
        color: red[400],

        '&$checked': {
            color: green[600],
        },

    },
    Grid: {
        margin: '5'
    },
    table: {
        flexGrow: 1,
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


export default function CapturaIdentificacion(props) {

    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [loadView, setLoadView] = useState(false)
    const [widthButton, setWidthButton] = useState(100)
    const [estados, setEstados] = useState([]);
    const localStyles = {} //useStyles()
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()
    const { t } = useTranslation();

    return (
        <div className={localStyles.root}>
            <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
            {/* <LoadingOverlay
                active={loadView}
                spinner
                text='Espere un momento por favor...'
                className={classes.loader}>
            </LoadingOverlay> */}
            <CustomCounterAppBar
                initialStep={currentStage}
                endingStep={totalStage} />

            <form onSubmit="" className={localStyles.formContainer}>
                <Typography variant="h6" gutterBottom className={localStyles.title}>Captura de identificacion </Typography>

                <div id='questionsContainer' className={localStyles.questionsContainer}>

                    <FormControl component="fieldset" className={GreenCheckbox.table}>
                        <Grid container spacing={2}>

                            <Grid container item xs={6} >
                                <Typography>  </Typography>
                            </Grid>
                            <Grid container item xs={3} >
                                {/* <Typography> INE</Typography> */}
                                <Typography></Typography>
                            </Grid>
                            <Grid container item xs={3} >
                                {/* <Typography> RENAPO</Typography> */}
                                <Typography></Typography>
                            </Grid>



                            <Grid container item xs={6} >
                                <Typography > Situacion Registral</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>


                            <Grid container item xs={6} >
                                <Typography > Vigente</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>


                            <Grid container item xs={6} >
                                <Typography > Nombre(s)</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>


                            <Grid container item xs={6} >
                                <Typography > Apellido Materno</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>


                            <Grid container item xs={6} >
                                <Typography > Apellido Paterno</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>


                            <Grid container item xs={6} >
                                <Typography > CURP</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>

                            <Grid container item xs={6} >
                                <Typography > Calve de Elector</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>

                            <Grid container item xs={6} >
                                <Typography > Año de emision</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>


                            <Grid container item xs={6} >
                                <Typography > Año de registro</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>

                            <Grid container item xs={6} >
                                <Typography > Numero de emision</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>

                            <Grid container item xs={6} >
                                <Typography > Numero de OCR</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>

                            <Grid container item xs={6} >
                                <Typography > Indice derecho</Typography>
                            </Grid>

                            <Grid container item xs={3} >
                                <FormControlLabel
                                    control={<img src={'/done.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >

                            </Grid>


                            <Grid container item xs={6} >
                                <Typography > Indice izquierdo</Typography>
                            </Grid>

                            <Grid container item xs={3} >

                                <FormControlLabel
                                    control={<img src={'/close.svg'} />}
                                />
                            </Grid>
                            <Grid container item xs={3} >

                            </Grid>
                        </Grid>
                    </FormControl>

                    <Buttons
                        className={localStyles.acceptBtn}
                        size={widthButton}
                        text_color='#FFFFFF'
                        background_color='#C20E30'
                        border_color='#C20E30'
                        text='Continuar'
                        type='submit' />
                </div>
            </form>
        </div>
    );
}